<template>
    <b-modal
        :id="id"
        modal-class="modal-fullscreen"
        style="max-width: 100% !important"
        centered
        header-class="voucherCode__modal-header"
        body-class="voucherCode__modal-body"
        hide-footer
        :hide-header-close="true"
        @hidden="$emit('onCancelModal')"
    >
        <template #modal-title>
            <h1 class="voucherCode__title">{{ getTranslatedText("Enter Voucher Code") }}</h1>
        </template>
        <div class="voucherCode">
            <b-form-input
                required
                :state="stateVoucherCode"
                v-model="voucher"
                @change="formatter"
                id="input-add-voucher">
            </b-form-input>
            <b-form-invalid-feedback id="input-voucher">
                {{ getTranslatedText("The voucher code is required") }}
            </b-form-invalid-feedback>
            <div class="voucherCode__btn-group">
                <b-button
                    class="voucherCode__button voucherCode__validate"
                    @click="onSubmitVoucher"
                    :disabled="isLoadingButton"
                >
                    <b-spinner v-if="isLoadingButton" />
                    {{ getTranslatedText("Validate Voucher")}}
                </b-button>
                <b-button
                    class="voucherCode__button voucherCode__cancel"
                    @click="$emit('onCancelModal')"
                >
                    {{ getTranslatedText("Cancel")}}
                </b-button>
            </div>
        </div>
    </b-modal>
</template>
<script>

import VoucherService from "@/services/voucher.service";

import languageMixin from "@/mixins/language/language-mixin";
import paymentMixin from "@/mixins/payment/payment-mixin"

import ButtonCustom from "@/components/common/button";
import EventBus from '@/components/common/EventBus'
import { isArrayEmpty } from "@/components/common/utils";

export default {
    mixins: [languageMixin, paymentMixin],
    components: {
        ButtonCustom
    },
    props: {
        id: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isLoadingButton: false,
            voucher: '',
            stateVoucherCode: null
        };
    },
    created() {
        EventBus.$on('onHideVoucherCode', () => {
            this.voucher = '';
            this.stateVoucherCode = null;
        })
    },
    destroyed() {
        EventBus.$off('onHideVoucherCode', () => {})
    },
    methods: {
        formatter(value) {
            if (!value) {
                this.stateVoucherCode = false;
            } else {
                this.stateVoucherCode = null;
            }
        },

        onSubmitVoucher() {
            if (!this.voucher) {
                this.stateVoucherCode = false;
            } else {
                try {
                    this.isLoadingButton = true;
                    VoucherService.addVoucherCode({
                        code: this.voucher
                    })
                    .then(res => {
                        if(res.status === 200) {
                            this.$emit("showToast", res.message, "success");
                            this.isLoadingButton = false;
                            this.$store.dispatch("setBalance");
                            this.$emit('onCancelModal');
                        } else {
                            let message = "";
                                !isArrayEmpty(res.errors)
                                    ? res.errors.forEach((element) => {
                                        message += element.message;
                                })
                            : (message = res.message);
                            this.$emit(
                                "showToast", message, "error"
                            );
                            this.isLoadingButton = false;
                        }
                    })
                } catch (error) {
                    console.log(error);
                }
                this.stateVoucherCode = null;
            }
        },
    },
};
</script>
<style scoped lang="scss" src="@/assets/scss/common/voucherCode/voucherCode.scss" />
